
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {licensedata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { message } from "antd";


interface licenseResponsePayloadInterface{
    data:{
    license:licensedata[],
    }
}

/** The licence list; archived (removed) licences only when asked for (anima_core #8). */
export const requestDataFromAPI =(includeArchived:boolean = false) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/License"+(includeArchived ? "?includeArchived=true" : ""),
            {},
            "GET",
            (payload:licenseResponsePayloadInterface) => {
                dispatch(
                     TableThingyActions.resetData(
                         {
                             license : payload.data.license,
                         }
                     )
                 );
                 console.log(payload);
            },
            ()=>{}
        ) as any)
    }
}

/**
 * Removes a licence (admin only, anima_core #8): the hub archives it - the
 * row stays, the list hides it, activate and verify no longer know it.
 * onDone runs after either answer, to reload what is shown.
 */
export const requestRemoveLicence =(uuid:string, onDone:() => void) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid,
            {},
            "DELETE",
            (payload:{status:string}) => {
                message.success(payload?.status ?? "License removed");
                onDone();
            },
            (payload:any) => {
                message.error(payload?.message ?? "License not removed.");
                onDone();
            },
        ) as any)
    }
}

/** Brings a removed (archived) licence back (admin only). */
export const requestRestoreLicence =(uuid:string, onDone:() => void) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/restore",
            {},
            "POST",
            (payload:{status:string}) => {
                message.success(payload?.status ?? "License restored");
                onDone();
            },
            (payload:any) => {
                message.error(payload?.message ?? "License not restored.");
                onDone();
            },
        ) as any)
    }
}
